module.exports = __webpack_public_path__ + "img/530.3805b8e8.jpg";